export const PHONE_NUMBER = '(206) 923-8886';
export const FAX_NUMBER = '(206) 338-9869';
export const EMAIL = 'info@generationsmhw.com';